const API_BASE = (import.meta.env.VITE_API_BASE_URL || '').replace(/\/+$/, '');

/** In dev, VITE_API_BASE_URL is empty → paths are relative (/api/...) and Vite proxy strips /api.
 *  In staging/prod, VITE_API_BASE_URL is set → paths are absolute (https://api-stg.../commander-go/...). */
const PATH_PREFIX = API_BASE ? `${API_BASE}/commander-go` : '/api/commander-go';

export const COMMANDER_GO_API_PATH = `${PATH_PREFIX}/chat`;
export const COMMANDER_GO_THREADS_PATH = `${PATH_PREFIX}/threads`;

export const COMMANDER_GO_DEFAULTS = {
  panelWidth: 560,
  placeholder: 'Ask about your data...',
  title: 'Commander Go',
} as const;

export const WELCOME_SUGGESTIONS: Record<string, string[]> = {
  crm: [
    'Show my top deals this quarter',
    "Which contacts haven't been reached in 30 days?",
    'Pipeline summary by stage',
    'My upcoming tasks this week',
  ],
  prospecting: [
    'Show my recent prospects',
    'Which companies match my sales strategy?',
    'Prospect activity summary this week',
    "Show prospects I haven't contacted yet",
  ],
  default: [
    'Show my top deals this quarter',
    'Pipeline summary by stage',
    "Which contacts haven't been reached in 30 days?",
    'My upcoming tasks this week',
  ],
};
